export default __webpack_public_path__ + "static/media/samir.a59127cb.png";